export enum PeFormResponse {
  Create,
  Submit,
  Accept,
  Reject,
  AutoReject,
  Override,
  Updated
}
